import { DailyGiftSlice } from "./types";

export const initialState: DailyGiftSlice = {
	data: undefined
};
